"use strict";

// Generated by CoffeeScript 1.12.7
(function () {
  var XMLComment,
    XMLNode,
    extend = function extend(child, parent) {
      for (var key in parent) {
        if (hasProp.call(parent, key)) child[key] = parent[key];
      }
      function ctor() {
        this.constructor = child;
      }
      ctor.prototype = parent.prototype;
      child.prototype = new ctor();
      child.__super__ = parent.prototype;
      return child;
    },
    hasProp = {}.hasOwnProperty;
  XMLNode = require('./XMLNode');
  module.exports = XMLComment = function (superClass) {
    extend(XMLComment, superClass);
    function XMLComment(parent, text) {
      XMLComment.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing comment text. " + this.debugInfo());
      }
      this.text = this.stringify.comment(text);
    }
    XMLComment.prototype.clone = function () {
      return Object.create(this);
    };
    XMLComment.prototype.toString = function (options) {
      return this.options.writer.set(options).comment(this);
    };
    return XMLComment;
  }(XMLNode);
}).call(this);